import React from 'react';
import { Box, Container, Typography, Grid, Avatar } from '@mui/material';
import TitlePage from '../components/TitlePage';
import { styled } from '@mui/material/styles';
import headerImage from '../assets/images/about/11.jpg';
import directorImage from '../assets/images/director/director.jpeg';
import CTASection from '../components/CTASection';

const MessageContainer = styled(Box)(({ theme }) => ({
  background: '#FFFFFF',
  borderRadius: '16px',
  border: '1px solid #E2E8F0',
  padding: '3rem',
  marginBottom: '2rem',
  position: 'relative',
  '&::before': {
    content: '""',
    position: 'absolute',
    left: 0,
    top: 0,
    bottom: 0,
    width: '4px',
    background: 'linear-gradient(135deg, #1A365D 0%, #004B87 100%)',
    borderRadius: '4px 0 0 4px'
  }
}));

const MessageText = styled(Typography)(({ theme }) => ({
  color: '#475569',
  fontSize: '1.1rem',
  lineHeight: 2,
  marginBottom: '3rem',
  fontStyle: 'italic',
  textAlign: 'justify',
  '& .paragraph': {
    marginBottom: '2rem',
    display: 'block'
  }
}));

const DirectorProfile = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: '2rem',
  background: '#FFFFFF',
  borderRadius: '16px',
  border: '1px solid #E2E8F0',
  height: '100%'
}));

const DirectorAvatar = styled(Avatar)(({ theme }) => ({
  width: 160,
  height: 160,
  marginBottom: '1.5rem',
  border: '4px solid #fff',
  boxShadow: '0 4px 20px rgba(0, 75, 135, 0.15)'
}));

const SignatureContainer = styled(Box)(({ theme }) => ({
  textAlign: 'right',
  marginTop: '2rem',
  paddingTop: '2rem',
  borderTop: '1px solid rgba(0, 75, 135, 0.1)'
}));

const DirectorMessage = () => {
  return (
    <Box>
      <TitlePage 
        title="Mot du Directeur" 
        image={headerImage}
      />
      
      <Container 
        maxWidth="xl"
        sx={{
          py: { xs: 6, md: 10 },
          px: { xs: 2, sm: 4, md: 8, lg: 12 }
        }}
      >
        <Grid container spacing={6}>
          <Grid item xs={12} md={4}>
            <DirectorProfile>
              <DirectorAvatar
                alt="Mr. Abdelali TAIAA"
                src={directorImage}
              />
              <Typography 
                variant="h4" 
                sx={{ 
                  color: '#1A365D',
                  fontWeight: 600,
                  mb: 1,
                  textAlign: 'center'
                }}
              >
                Mr. Abdelali TAIAA
              </Typography>
              <Typography 
                sx={{ 
                  color: '#475569',
                  fontSize: '1.1rem',
                  textAlign: 'center'
                }}
              >
                Directeur du Laboratoire AIR METROLOGIE et L2MI
              </Typography>
            </DirectorProfile>
          </Grid>

          <Grid item xs={12} md={8}>
            <MessageContainer>
              <MessageText>
                <span className="paragraph">
                  "Depuis la création des laboratoires AIR METROLOGIE-L2MI, notre priorité a toujours été d'offrir des prestations de haute qualité en respectant les standards les plus stricts en métrologie. Nos accréditations attestent de notre engagement envers la précision, la fiabilité et l'amélioration continue de nos services.
                </span>

                <span className="paragraph">
                  Les laboratoires disposent d'une équipe jeune et compétente, dynamique et engagée, qui met son expertise au service de la métrologie de haute qualité. Grâce à des connaissances actualisées et des formations continues, notre équipe est en mesure de répondre efficacement aux exigences les plus rigoureuses. Nous privilégions une approche proactive et innovante pour garantir des prestations à la hauteur des attentes de nos clients, tout en respectant les normes en vigueur. Cette combinaison de jeunesse et de savoir-faire assure une grande réactivité et une qualité de service optimale.
                </span>

                <span className="paragraph">
                  Les laboratoires sont également équipés d'étalons de haute précision, régulièrement calibrés et conformes aux normes internationales de métrologie. Ces étalons garantissent la fiabilité des mesures effectuées, en assurant une traçabilité rigoureuse et une exactitude optimale. Ils constituent un élément essentiel dans nos processus de contrôle, permettant d'assurer la qualité et la conformité de nos prestations. Grâce à un entretien régulier et à l'utilisation d'équipements de pointe, nos étalons sont toujours prêts à répondre aux exigences des clients, contribuant ainsi à la fiabilité des résultats obtenus.
                </span>

                <span className="paragraph">
                  Nous croyons fermement que la confiance de nos clients repose sur notre capacité à fournir des résultats précis et conformes. C'est pourquoi nous investissons constamment dans la formation de nos équipes et l'amélioration de nos équipements tout en veillant à poursuivre nos politiques qualité de manière active et suivie pour l'atteinte de notre premier objectif qui est la satisfaction de nos clients.
                </span>

                <span className="paragraph">
                  Nous sommes convaincus que la rigueur, l'expertise et l'innovation sont les piliers de notre réussite et de la satisfaction de notre clientèle.
                </span>

                <span className="paragraph">
                  Nous vous remercions de continuer à nous faire confiance pour vos besoins en métrologie. Nous sommes déterminés à maintenir les plus hauts standards pour vous accompagner dans vos projets."
                </span>
              </MessageText>

              <SignatureContainer>
                <Typography 
                  sx={{ 
                    color: '#1A365D',
                    fontSize: '1.2rem',
                    lineHeight: 1.7,
                    fontWeight: 600
                  }}
                >
                  Mr. Abdelali TAIAA
                </Typography>
                <Typography 
                  sx={{ 
                    color: '#475569',
                    fontSize: '1.1rem',
                    lineHeight: 1.7,
                    fontStyle: 'italic'
                  }}
                >
                  Directeur du Laboratoire AIR METROLOGIE et L2MI
                </Typography>
              </SignatureContainer>
            </MessageContainer>
          </Grid>
        </Grid>
      </Container>

      <CTASection />
    </Box>
  );
};

export default DirectorMessage;
